import { get as getCookie } from 'js-cookie';
import { getSafeExperimentsContext, type InitErrorBoosterConfig } from '@adv-frontend/yastore-modules/lib';
import { getRequestContext } from '../context';
import { pathToPageName } from '../dom';
import { getMonitoringExperiments } from '../experiments';
import { getErrorBoosterGlobalAdditional } from './getErrorBoosterGlobalAdditional';
import { transformErrorBoosterError } from './transformErrorBoosterError';

export function getErrorBoosterInitConfig(pathname: string): InitErrorBoosterConfig {
    const requestContext = getRequestContext();
    const commit =
        typeof document === 'undefined'
            ? undefined
            : document.querySelector('meta[name="kit-commit"]')?.getAttribute('content')?.trim();

    return {
        project: 'yastore-b2b',
        version: commit && commit !== 'unknown' ? commit : undefined,
        page: pathToPageName(pathname),
        env: requestContext.env,
        platform: requestContext.platform,
        experiments: getMonitoringExperiments(getSafeExperimentsContext()).experiments,
        yandexuid: getCookie('yandexuid'),
        referrer: true,
        preventError: false,
        unhandledRejection: true,
        uncaughtException: true,
        debug: false,
        transform: transformErrorBoosterError,
        additional: getErrorBoosterGlobalAdditional(),
        /* Отправлять не больше чем указанное количество ошибок каждого типа от одного пользователя */
        limits: {
            client: 1000,
            uncaught: 100,
            script: 100,
            external: 100,
        },
        /* На графиках выводить не больше чем указанное количество ошибок каждого типа от одного пользователя */
        silent: {
            client: 100,
            uncaught: 10,
            script: 10,
            external: 10,
        },
        initTimestamp: Date.now(),
    };
}
